import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService, AuthenticationService, ClientProfileService, UserService} from '../../_services/index';

import {User} from '../../_models/index';

import {LoginHelper} from '../../helpers';

import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';

import {TenantPermissionsEditComponent} from "../tenantPermissionsEdit";
import {TenantPermissions} from "../../_models/tenantPermissions";
import {TenantPermissionsService} from "../../_services/tenantPermissions.service";
import {Constants} from "../../helpers/constants";

@Component({
    standalone: false,
  selector: "tenantPermissions-component",
  templateUrl: 'tenantPermissions.component.html',
  styleUrls: ['./tenantPermissions.component.scss'],
})

export class TenantPermissionsComponent implements OnInit {
  users: User[];
  msg: string;
  tenantPermissions: TenantPermissions[];
  dialogRef: MatDialogRef<TenantPermissionsEditComponent> | null;
  defaultTenantPermissionsId?: number;
  host: string = '';

  cols : any[] = [
    {'field': 'name', 'header': 'Name', width: '20%'},
    {'field': 'description', 'header': 'Description', width: '30%'},
  ]

  rowGroupMetadata = {};

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public userService: UserService,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public tenantPermissionsService: TenantPermissionsService,
    public clientProfileService: ClientProfileService,
    public dialog: MatDialog) {
  }

  ngOnInit() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    const parts = location.hostname.split('.');
    if (parts.length > 2)
    {
      parts.shift();
    }

    this.host = parts.join(".");

    this.clientProfileService.getSettings(Constants.RiskSpongeMaster).subscribe(t => this.defaultTenantPermissionsId = t.defaultTenantPermissions)
    this.loadTenantPermissions();
  }

  editTenantPermissions(tenantPermissionsId?: number) {

    let tenantPermissions =
      this.tenantPermissions.find(x => x.tenantPermissionsId == tenantPermissionsId);

    //user.tenantName = LoginHelper.getTenantName();
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      minWidth: "300px",
      height: '90vh',
      data: {
        tenantPermissions: tenantPermissions || {}
      }
    };

    this.dialogRef = this.dialog.open(TenantPermissionsEditComponent, config);

    this.dialogRef.afterClosed().subscribe((result: any) => {
      this.alertService.suppressRootAlert.next(false);
      this.alertService.clear();

      this.loadTenantPermissions();
    });
  }

  deleteTenantPermissions(tenantPermissionsId: number) {

    this.tenantPermissionsService.deleteTenantPermissions(tenantPermissionsId).subscribe(data => {
        this.loadTenantPermissions();
      },
      (error: Response) => {
        const errorMessage = 'An error occurred while deleting edition.';
        this.alertService.error(errorMessage);
      });
  }

  public loadTenantPermissions() {
    this.tenantPermissionsService.getAllTenantPermissions().subscribe(data => {
        this.tenantPermissions = data;
      },
      error => {
        console.log(error);
        const errorMessage = 'An error occurred while loading users.';
        this.alertService.error(errorMessage);
      });
  }

  protected setDefault(id){
    this.defaultTenantPermissionsId = id;
    this.clientProfileService.getSettings(Constants.RiskSpongeMaster).subscribe(t => {
      t.defaultTenantPermissions = id;
      this.clientProfileService.saveSettings(t, Constants.RiskSpongeMaster).subscribe(() => {})
    });
  }
}
